export default {
  styleOverrides: {
    root: {
      padding: 0,
      height: '50px',
      '& .MuiInputBase-small': {
        paddingBottom: 0,
      },
      '& label': {
        fontSize: 12,
        color: '#00B6B0',
      },
      '& .MuiInputBase-root:before': {
        content: 'none',
      },
      '& .MuiInputBase-root:after': {
        content: 'none',
      },
    },
    input: {
      fontSize: 14,
      paddingTop: '0 !important',
      paddingBottom: '7px !important',
    },
    listbox: {
      '.mui-jss-MuiAutocomplete-option': {
        padding: '6px 16px',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#f5f5f5',
        },
      }
    },
  },
}
